module.exports = __webpack_public_path__ + "img/landing-invest-strategies.0fa2afd1.svg";